import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetVaccineGroupDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/VaccineGroup/GetDetail?` + params, null);

export const GetVaccineGroupList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/VaccineGroup/GetList?` + params, null);

export const CreateVaccineGroup = (data: any) =>
  POST_ENC(`${BASE_URL}/api/VaccineGroup/Create`, data);

export const UpdateVaccineGroup = (data: any) =>
  POST_ENC(`${BASE_URL}/api/VaccineGroup/Update`, data);    

export const DeleteVaccineGroup = (data: any) =>
  POST_ENC(`${BASE_URL}/api/VaccineGroup/Delete`, data);
